<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Password</span>
		</div>
		
		<div>
			<div>
				<div class="box-name">Old Password:</div>
				<input class="box-input" type="password" v-model="oldpwd">
			</div>
			<div>
				<div class="box-name">New Password:</div>
				<input class="box-input" type="password" v-model="newpwd">
			</div>
			<div>
				<div class="box-name">Confirm New Password:</div>
				<input class="box-input" type="password" v-model="cpwd">
			</div>
			
			<div style="background: linear-gradient(90deg, #31FFDA 0%, #00EDD8 100%);border-radius: 0.2rem;margin-top: 1rem;display: flex;align-items: center;justify-content: center;font-size: 1.2rem;
					margin-top: 3rem;cursor: pointer;border: none;" class="box-input" @click="save">
				save
			</div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {baseUrl} from '../../assets/js/public.js'
		import md5 from 'js-md5'
		export default {
			data() {
				return {
					type:0,
					oldpwd:'',
					newpwd:'',
					cpwd:'',
				}
			},
			components: {
			},
			methods: {
				save(){
					let pwdReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/
					if(this.newpwd != this.cpwd){
						// alert('password different')
						this.$bus.$emit('message', {
							type:1,
							msg:'password different'
						})
					}else if(this.oldpwd == ''||this.newpwd==''||this.cpwd==''){
						// alert('enter your password')
						this.$bus.$emit('message', {
							type:1,
							msg:'enter your password'
						})
					}else if(!pwdReg.test(this.newpwd)){
						this.$bus.$emit('message',{
							type:1,
							msg:'Passwords must contain letters and numbers and have a length greater than 6'
						})
					}else{
						
						let params = {
							newPassword: md5(this.newpwd),
							newPassword2:md5(this.cpwd),
							oldPassword:md5(this.oldpwd),
						}
						this.request({
							method: 'post',
							url: '/gci/auth/updatePassword',
							data:params
						}).then(res => {
							// alert(res.msg)
							if(res.status==0){
								this.oldpwd = ''
								this.newpwd = ''
								this.cpwd = ''
								this.$bus.$emit('message', {
									type:2,
									msg:res.msg
								})
							}else{
								
								this.$bus.$emit('message', {
									type:3,
									msg:res.msg
								})
							}
						}).catch(error => {
							console.error(error.response)
						})
					}
				},
			},
			mounted() {
				this.type = this.$route.query.type
				
			}
		}
</script>

<style lang="scss" scoped>
	.box-name{
		color: #333;font-size: 1rem;margin-top: 1rem;font-weight: bold;
	}
	.box-input{
		border: 1px solid #eee;padding: 0.5rem;background-color: #fff;margin-top: 0.5rem;width: 100%;font-size: 1rem;border-radius: 0.2rem;
	}
	input::placeholder{
		color: #999999;opacity: 0.6;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
</style>